import { IFsMap } from '../types';

export abstract class FsMapRegistryCamerasServiceProvider<TMap extends IFsMap> {
  public abstract get isAvailable(): boolean;

  public abstract onMapLoaded(map: TMap): void;
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;
}